import { SERVICE_ROUND_SET_ACTIVE } from '@/store/modules/service/rounds/mutation-types'

export default {
  [SERVICE_ROUND_SET_ACTIVE]: (state, rondeActive) => {
    state.rondeActive = rondeActive
  }
}
